import React from "react";

const Anuncio = () => {
    const anuncios = [
      {
        id: 1,
        descripcion: `Estimados Papitos, les recordamos que el pago de la pensión se puede realizar mediante <strong>transferencia bancaria</strong> a la siguiente cuenta:<br/><br/>
        ✅ Cuenta de ahorros Bancolombia: <strong>45500000813</strong><br/>
        ✅ Titular: <strong>Yennie del Pilar Varón</strong><br/>
        ✅ C.C.: <strong>1075247874</strong><br/><br/>
        🚫 No contamos con NEQUI, ni otras cuentas bancarias.<br/><br/>
        Agradecemos su puntualidad en los pagos. 💼`,
      },
    ];

  return (
    <div className="flex flex-col gap-4 bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-auto">
      <h2 className="text-2xl font-bold text-center flex items-center justify-center gap-2">
        <span role="img" aria-label="megáfono"></span> 📢 Información de Pago de Pensión 📢 
      </h2>

      <div className="max-h-[600px] overflow-y-auto scrollbar-custom w-full">
        {anuncios.length === 0 ? (
          <p className=" text-center">No hay anuncios disponibles.</p>
        ) : (
          anuncios.map((anuncio) => (
            <div
              key={anuncio.id}
              className="bg-white p-4 rounded-lg shadow-md border border-gray-200 flex flex-col mb-4"
            >
              <h3 className="text-lg font-semibold text-center text-gray-800">
                {anuncio.titulo}
              </h3>
              <p
                className="text-sm text-gray-600 mt-2 break-words"
                dangerouslySetInnerHTML={{ __html: anuncio.descripcion }}
              ></p>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Anuncio;